import { Employee9BoxTalentMatrix } from 'components/employee-analytics/analytic-item/Employee9BoxTalentMatrix'
import moment from 'moment'
import { useState, useEffect } from 'react'
import { API_EMPLOYEE_ANALYTICS } from 'services/apiEmployeeAnalytics'
import { useFetch } from 'services/useFetch'
import { getYears } from 'utils/utils'

const INITIAL_FILTER = {
    year: moment().get('year'),
    company_ids: [],
    department_ids: [],
    division_ids: [],
    sub_division_ids: [],
}

const Employee9BoxTalentMatrixContainer = () => {
    const { fetching: getTalentMatrix, isLoading } = useFetch(API_EMPLOYEE_ANALYTICS.NINE_BOX_TALENT_MATRIX)
    const [talentMatrixData, setTalentMatrixData] = useState([])
    const [filter, setFilter] = useState(INITIAL_FILTER)

    const styleBar = (key) => {
        switch (key) {
            case 'Rock Star':
                return { bgColor: 'bg-[#F3DFC5]' }
            case 'Rising Star':
                return { bgColor: 'bg-[#DCEAF6]' }
            case 'Mega Star':
                return { bgColor: 'bg-[#1F3441]', textColor: 'text-white', descriptionColor: 'text-neutral-30' }
            case 'Emerging Star':
                return { bgColor: 'bg-[#F1D8D4]' }
            case 'Promising Star':
                return { bgColor: 'bg-[#D6DEE3]' }
            case 'Super Star':
                return { bgColor: 'bg-[#D3E3F1]' }
            case 'Falling Star':
                return { bgColor: 'bg-[#E2B3AA]' }
            case 'Aspiring Star':
                return { bgColor: 'bg-[#FAF1D6]' }
            case 'Bright Star':
                return { bgColor: 'bg-[#DFF2E1]' }
            default:
                return { bgColor: 'bg-neutral-20' }
        }
    }

    useEffect(() => {
        ;(async () => {
            const talentMatrix = await getTalentMatrix(filter)
            const newData = talentMatrix?.data?.matrix?.map((item) => {
                const { potential_category, performance_category, ...restItem } = { ...item }
                return {
                    ...restItem,
                    description: `(${item?.potential_category} Potential, ${item?.performance_category} Performance)`,
                    ...styleBar(item?.nine_box_label),
                }
            })

            setTalentMatrixData(newData)
        })()
    }, [filter])

    const onSubmitFilter = (newFilter) => {
        if (JSON.stringify(filter) !== JSON.stringify(newFilter)) {
            setFilter(newFilter)
        }
    }

    const props = {
        data: talentMatrixData,
        isLoading,
        filter,
        onSubmitFilter,
        years: getYears(2021),
    }

    return <Employee9BoxTalentMatrix {...props} />
}

export default Employee9BoxTalentMatrixContainer
